export default __webpack_public_path__ + "static/media/HFS00513_WEDDING_1084_tn.31a0aedf.jpg";